import { render, staticRenderFns } from "./product-aspects-full.vue?vue&type=template&id=1d3a5a6c&"
import script from "./product-aspects-full.vue?vue&type=script&lang=ts&"
export * from "./product-aspects-full.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/scss/form.scss?vue&type=style&index=0&lang=scss&module=styleForm&"
import style1 from "./product-aspects-full.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleForm"] = (style0.locals || style0)
this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports